"use client";

import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";

import { abCache } from "../lib";
import type { HallowABFlag } from "../types";

export type UseFlagProps = { key: HallowABFlag };

export const useFlag = ({ key }: UseFlagProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [value, setValue] = useState(abCache.get(key));

  const flags = useFlags();

  /**
   * useFlags() returns a proxy
   * Analytic events are emitted on GET for the proxy
   * To limit duplicate analytic events, use cache if possible
   */
  useEffect(() => {
    if (!abCache.has(key)) {
      const flagLookupValueWithAnalyticsEvent = flags[key];
      abCache.set(key, flagLookupValueWithAnalyticsEvent);
      setValue(flagLookupValueWithAnalyticsEvent);
    }
    setIsLoading(false);
  }, [flags]);

  return { isLoading, value };
};
